import { makeHttpRequest } from "@/shared";

import { mapCalculatedRentFromServer } from "./mappers/mapCalculatedRentFromServer";
import { mapRentProductToServer } from "./mappers/mapRentProductToServer";

export const removeProductFromRent = async (sessionKey, product) => {
    const response = (
        await makeHttpRequest({
            url: `/rent/builder/${sessionKey}/remove/product`,
            method: "DELETE",
            data: mapRentProductToServer(product),
        })
    ).data;

    return mapCalculatedRentFromServer(response.data);
};
